<a
	*ngIf="imageUrl"
	[tabindex]="-1"
	maybeExternal
	[maybeExternalCurrentTab]="true"
	[href]="link"
	i18n="@@HeroItemMainImage-{{imageAltText}}"
	(click)="onClickMainImage()"
>
	<img
		width="1608"
		height="864"
		class="hero-item-main-image"
		[alt]="imageAltText"
		[ngClass]="{ 'main-image-error': showImageError }"
		[loading]="loadingStrategy"
		[src]="imageUrl"
		(error)="handleImageError()"
	/>
</a>
